<template>
    <div class="col-md-12" :class="{'card':onCard}" >
      <div class="card-header">
        <h4 class="card-title">
          Event History
        </h4>
      </div>
      <div class="card-content form-horizontal">
  <time-line type="simple">
    
    <time-line-item 
      v-for="evt in events" 
      :key="evt.id" 
      class="timeline-inverted" 
      :badge-type="formatBadgeType(evt.type, evt.event)" 
      :badgeIcon="formatBadgeIcon(evt.type, evt.event)">
      <!-- <span slot="header" class="label" :class="labelClass(evt.type, evt.event)">{{formatEventType(evt.type)}}</span> -->
      <p slot="header">{{evt.event}}</p>
      <h6 slot="footer">
        <i class="ti-time"></i>
        {{formatDate(evt.created)}}
      </h6>
    </time-line-item>

  </time-line>
      </div>
    </div>
</template>

<script>
  import moment from 'moment'
  import TimeLine from 'src/components/TimeLine/TimeLine.vue'
  import TimeLineItem from 'src/components/TimeLine/TimeLineItem.vue'

  export default {
    name: 'verification-timeline',
    components: {
      TimeLine,
      TimeLineItem
    },
    props: {
      events: Array,
      onCard: {type: Boolean, default: true}
    },
    methods: {
      formatBadgeType(type, message) {
        if(type === 'VERIFICATION_INSTITUTE_ACTION') {
          if(message.includes(' changed status to Action Required')) return 'warning'
          if(message.includes(' changed status to Not Verified')) return 'danger'
          if(message.includes(' changed status to Verified')) return 'success'
        }
        return 'plain'
      },
      formatBadgeIcon(type, message) {
        
        switch(type) {
          case 'VERIFICATION_SYSTEM_ACTION': return 'fa fa-cog'
          case 'ADMIN_COMMENT': return 'fa fa-comment'
          case 'VERIFICATION_USER_ACTION': return 'fa fa-mail-forward'
          case 'VERIFICATION_INSTITUTE_ACTION': return 'fa fa-university'
          default: return 'fa fa-exclamation'
        }
      },
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY HH:mm')
      },
      // formatEventType(type) {
      //   switch(type) {
      //     case 'VERIFICATION_SYSTEM_ACTION': return 'System'
      //     case 'ADMIN_COMMENT': return 'Qualification Check Admin Comment'
      //     case 'VERIFICATION_USER_ACTION': return 'User Event'
      //     case 'VERIFICATION_INSTITUTE_ACTION': return 'Institute / Organisation Response'
      //     default: return type
      //   }
      // },
      labelClass(type, message) {
        if(type === 'VERIFICATION_INSTITUTE_ACTION') {
          if(message.includes(' changed status to Action Required')) return 'label-warning'
          if(message.includes(' changed status to Not Verified')) return 'label-danger'
          if(message.includes(' changed status to Verified')) return 'label-success'
        }
        return 'label-white'
      }
    }
  }
</script>